import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { LanguageProvider } from './contexts/LanguageContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import LivePage from './pages/LivePage';
import LiveBadge from './components/LiveBadge';
import PageTransition from './components/PageTransition';

function AppContent() {
  const location = useLocation();

  return (
    <div className="App flex min-h-screen flex-col">
      <Navigation />
      <div className="flex-1">
        <AnimatePresence mode="wait" key={location.pathname}>
          <PageTransition key={location.pathname}>
            <Routes location={location}>
              <Route path="/" element={<HomePage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/projects/:id" element={<ProjectDetailPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/live" element={<LivePage />} />
            </Routes>
          </PageTransition>
        </AnimatePresence>
      </div>
      <Footer />
      <LiveBadge />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppContent />
      </Router>
    </LanguageProvider>
  );
}

export default App; 